export class AssetModel {
    constructor() {
        this.Id = 0;
        this.AssetTypeDescription = "";
        this.AssetLink = "";
    }
}